var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2898 11.9997L14.8298 8.4597C15.0161 8.27234 15.1206 8.01889 15.1206 7.7547C15.1206 7.49052 15.0161 7.23707 14.8298 7.0497C14.7369 6.95598 14.6263 6.88158 14.5044 6.83081C14.3825 6.78004 14.2518 6.75391 14.1198 6.75391C13.9878 6.75391 13.8571 6.78004 13.7352 6.83081C13.6134 6.88158 13.5028 6.95598 13.4098 7.0497L9.16982 11.2897C9.07609 11.3827 9.0017 11.4933 8.95093 11.6151C8.90016 11.737 8.87402 11.8677 8.87402 11.9997C8.87402 12.1317 8.90016 12.2624 8.95093 12.3843C9.0017 12.5061 9.07609 12.6167 9.16982 12.7097L13.4098 16.9997C13.5033 17.0924 13.6141 17.1657 13.7359 17.2155C13.8578 17.2652 13.9882 17.2905 14.1198 17.2897C14.2514 17.2905 14.3819 17.2652 14.5037 17.2155C14.6256 17.1657 14.7364 17.0924 14.8298 16.9997C15.0161 16.8123 15.1206 16.5589 15.1206 16.2947C15.1206 16.0305 15.0161 15.7771 14.8298 15.5897L11.2898 11.9997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.750acee73bc641e6de73e85684bed1fe.svg";
export { ForwardRef as ReactComponent };